const logo = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSLTesEKlsvnzNZ9Gb4pHf4ehh6RImsXb1jbw&usqp=CAU";
//const serverUrl = "http://localhost:8080";
const serverUrl = "https://node.cgrum.com";

export { serverUrl, logo };
